declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_simple_typed_null_foo extends $mol_object {
		a( ): string|number | null
	}
	
}

//# sourceMappingURL=simple_typed_null.view.tree.d.ts.map